// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import { manufacturerIsValid } from 'validators/common'

const asyncValidate = async (formValues, f, props, pathString) => {
  // async validation fires one last time on submit
  // but does not include a pathString value
  // for this case, validating once again is unnecessary
  if (!pathString) {
    return
  }

  const inputName = pathString.substring(pathString.lastIndexOf(']') + 1)

  switch (inputName) {
    case 'companyName' :
      return manufacturerIsValid(formValues, f, props, pathString, 'radio')

    default :
      console.warn(`Unmapped input field has been assigned to async validate.`)
      return
  }
}

export default asyncValidate
